<template>
  <section class="media-wrapper" v-on:click="togglePopup(popupVisible, $event)">
    <div class="zoom-overlay">
      <FaIcon icon="expand" class="expand-image-icon"></FaIcon>
    </div>
    <Popup
      @open="popupVisible = true"
      @close="popupVisible = false"
      ref="mediaPopup"
    >
      <Media :data="mediaData" @load="$emit('load')"> </Media>
    </Popup>
    <Media class="thumbnail-media" :data="mediaData"></Media>
  </section>
</template>

<script>
import Popup from './ui/Popup'
import Media from './Media'
import FaIcon from './ui/FaIcon'

export default {
  name: 'QuestionVisualMedia',
  components: { FaIcon, Media, Popup },
  props: {
    mediaData: Object,
  },
  data() {
    return {
      popupVisible: false,
    }
  },
  methods: {
    /**
     * If popup is already open, we should be able to close it when clicking on the thumbnail
     * @param {boolean} popupVisible
     * @param {Object} event
     */
    togglePopup(popupVisible, event) {
      this.$refs.mediaPopup.togglePopup(!popupVisible, event)
    },
  },
}
</script>

<style lang="scss" scoped>
.media-wrapper {
  position: relative;

  .zoom-overlay {
    display: none;
  }

  @media (hover: hover) {
    .zoom-overlay {
      $gapSize: 1em;
      position: absolute;
      display: block;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 0;

      background-color: rgba(255, 255, 255, 0.51);
      opacity: 0;

      transition: all 0.2s ease-in;
      cursor: pointer;

      > .expand-image-icon {
        position: absolute;
        top: 50%;
        right: 50%;
        transform: translate(50%, -50%);
        z-index: 1;
        font-size: 2em;
      }
      &:hover {
        z-index: 1;
        opacity: 1;
      }
    }
  }
}

.thumbnail-media {
  margin: 0 auto;
}
</style>
